import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { resetButton } from "../../../lib/styles/Mixins";
export var styles = memoizeStyle({
  root: function root(t) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      ", "\n      display: inline-block;\n      position: relative;\n      border-radius: ", ";\n      color: ", ";\n      cursor: pointer;\n      transition: color ", " ", ";\n\n      &:enabled:focus,\n      &:enabled:hover {\n        color: ", ";\n      }\n    "])), resetButton(), t.closeBtnIconBorderRadius, t.closeBtnIconColor, t.transitionDuration, t.transitionTimingFunction, t.closeBtnIconHoverColor);
  },
  rootDisabled: function rootDisabled(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.closeBtnIconDisabledColor);
  },
  focus: function focus(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      box-shadow: ", ";\n    "])), t.closeBtnIconFocusShadow);
  },
  wrapper: function wrapper() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      box-sizing: content-box;\n      display: flex;\n      width: 100%;\n      height: 100%;\n      align-items: center;\n      justify-content: center;\n      pointer-events: none;\n    "])));
  }
});